import React from 'react'
import { history } from '../store'

class ContractActiveList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        customer: '',
        serial: '',
        mode: '',
      },
    };
  }
  goTo(id, e) {
    e.stopPropagation();
    history.push(`/contracts/${id}`)
  }

  goToCalendar(id, e) {
    e.stopPropagation();
    history.push(`/calendars/${id}`)
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  formatMinutesToHHMM = (minutes) => {
    const hrs = String(Math.floor(minutes / 60));
    const mins = String(minutes % 60).padStart(2, '0');
    return `${hrs}:${mins}`;
  };

  workingMode(type) {
    switch (type) {
      case "0":
        return "MTO DIARIO"
      case "1":
        return "MTO DIARIO + SERVICIOS"
      case "2":
        return "MTO DIARIO TIEMPO SIN PIN"
      case "3":
        return "MTO DIARIO TIEMPO CON PIN"
      case "4":
        return "OTO DIARIO SIN PIN"
      case "5":
        return "OTO DIARIO CON PIN"
      case "6":
        return "RESERVA ANTICIPADA"
      case "7":
        return "TAQUILLAS AQUARIAZ"
    }
  }

  render() {
    const { filters } = this.state;
    const { contracts } = this.props;

    // Apply the filters to filter the contracts array
    const filteredContractActive = contracts.filter(contract => {
      const { customer: customerFilter, serial: serialFilter, mode: modeFilter } = filters;

      if (
        customerFilter &&
        (!contract.Customer ||
          !contract.Customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        serialFilter &&
        (!contract.Machine ||
          !contract.Machine.Serial.toLowerCase().includes(serialFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        modeFilter &&
        contract.WorkingMode !== modeFilter) {
        return false;
      }

      // If all conditions pass, include the customer in the filtered list
      return true;
    });

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Máquina</th>
              <th scope="col">Cliente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Híbrido</th>
              <th scope="col">Zona</th>
              <th scope="col">Calendario de precios</th>
              <th scope="col">Fechas</th>
              <th scope="col">Acceso</th>
              <th scope="col">Estado</th>
            </tr>
            <tr>
              <th scope="col">
                <input
                  type="text"
                  placeholder="Serial"
                  value={filters.serial}
                  onChange={e => this.handleFilterChange('serial', e.target.value)}
                />
              </th>

              <th scope="col">
                <input
                  type="text"
                  placeholder="Cliente"
                  value={filters.customer}
                  onChange={e => this.handleFilterChange('customer', e.target.value)}
                />
              </th>
              <th scope="col">
                <select
                  className="w-100"
                  value={filters.mode}
                  onChange={e => this.handleFilterChange('mode', e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="0">MTO DIARIO</option>
                  <option value="1">MTO DIARIO + SERVICIOS</option>
                  <option value="2">MTO DIARIO TIEMPO SIN PIN</option>
                  <option value="3">MTO DIARIO TIEMPO CON PIN</option>
                  <option value="4">OTO DIARIO SIN PIN</option>
                  <option value="5">OTO DIARIO CON PIN</option>
                  <option value="6">RESERVA ANTICIPADA</option>
                  <option value="7">TAQUILLAS AQUARIAZ</option>
                </select>
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {filteredContractActive
              .sort((a, b) => a.Machine.Serial.localeCompare(b.Machine.Serial))
              .map(contract => (
                contract.Status !== "TERMINATED" ? (
                  <tr key={contract.number}
                    onClick={e => this.goTo(contract._id, e)}>
                    <td>{contract.Machine.Serial}</td>
                    <td>{contract.Customer.Fullname}</td>
                    <td>{this.workingMode(contract.WorkingMode)} {(contract.WorkingMode === "2" || contract.WorkingMode === "3") ? `( ${this.formatMinutesToHHMM(contract.TimeSlots)} )` : ''} </td>
                    <td>
                      <span className={`badge ${contract.HybridMode ? 'badge-success' : 'badge-secondary'}`}>
                        <i className={`fas ${contract.HybridMode ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                        {contract.HybridMode ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>{contract.Zone}</td>
                    <td>
                      <button className="btn bg-warning text-dark" onClick={e => this.goToCalendar(contract.Calendar._id, e)}>{contract.Calendar ? contract.Calendar.Name : 'Precios fijos'}</button>
                    </td>
                    <td>
                      {(new Date(contract.StartDate)).toDateString()}<br></br>
                      {(new Date(contract.EndDate)).toDateString()}
                    </td>
                    <td>{contract.DoorAccess}</td>
                    <td>{contract.Status}</td>
                  </tr>
                ) : null
              ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default ContractActiveList

